// extracted by mini-css-extract-plugin
export default {"titleBlock":"Title_titleBlock__Nb9A8","title":"Title_title__0i4lj","lastWord":"Title_lastWord__VJAVX","titleBg":"Title_titleBg__qNHrK"};